<coso-page-header [title]="'Configurations'"></coso-page-header>
@if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message> {{ successMessage }} </coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (pageResult$ | async; as pageResult) {
<coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="pageResult.items">
  <a topBarLeft class="btn btn-primary" [class.disabled]="isReadOnly" routerLink="create"><span class="fa fa-plus mr-1" aria-hidden="true"></span>Create new</a>
  <form topBarRight #searchForm="ngForm" (ngSubmit)="onQuickFilterChanged()">
    <div class="input-group input-group-sm">
      <input
        type="text"
        id="search"
        name="search"
        class="form-control"
        placeholder="Search this view"
        aria-label="Search for a string value in Message or Additional Info columns in the table"
        aria-describedby="search-addon"
        [(ngModel)]="quickFilterText"
      />
      <div class="input-group-append">
        <button type="submit" class="btn btn-primary" id="search-addon" aria-label="Start search on table"><i class="fa fa-search" aria-hidden="true" title="Search"></i></button>
        <button type="button" class="btn btn-dark" id="clear-addon" aria-label="Clear" (click)="onQuickFilterClear()"><i class="fa fa-times" aria-hidden="true" title="Clear"></i></button>
      </div>
    </div>
  </form>
</coso-grid>
@if (pageResult && pageResult.totalNumberOfItems > 0) {
<coso-paginator [pageSize]="itemsPerPage" [rowCount]="pageResult.totalNumberOfItems" [recordsTotal]="recordsTotal" (paginationChanged)="onPaginationChanged($event)"></coso-paginator>
} } @if (isSaaS) {
<coso-token-activation></coso-token-activation>
}

<ng-template #configurationId let-params="params">
  <span class="mx-2">
    @if (isSaaS) {
    <span class="text-muted">[#{{ params.data.legacyId }}]</span>
    } {{ params.data.id }}
  </span>
</ng-template>

<ng-template #queueStatus let-params="params">
  <div aria-live="polite">
    @if (params.data.queues && isRunning(params.data.status)) {
    <span class="mx-2" data-toggle="tooltip" data-placement="top" [title]="'Number of Dynamics 365 events waiting to be processed'">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      {{ params.data.queues.eventQueue || "0" }}
    </span>
    <span class="mx-2" data-toggle="tooltip" data-placement="top" [title]="'Number of SharePoint document locations to check for permission changes'">
      <i class="fa fa-search" aria-hidden="true"></i>
      {{ params.value.queues.calculateQueue || "0" }}
    </span>
    <span class="mx-2" data-toggle="tooltip" data-placement="top" [title]="'Number of SharePoint document locations waiting to be secured'">
      <i class="fa fa-users" aria-hidden="true"></i>
      {{ params.data.queues.writerQueue || "0" }}
    </span>
    } @else {
    <span>-</span>
    }
  </div>
  <ng-template #noQueues>
    <span>-</span>
  </ng-template>
</ng-template>

<ng-template #status let-params="params">
  <div class="d-flex align-items-center" aria-live="polite">
    @switch (params.data.status) { @case (Status.Started) {
    <span class="badge badge-success">Started</span>
    } @case (Status.Starting) {
    <span class="badge badge-success">Starting</span>
    } @case (Status.InitialLoading) {
    <span class="badge badge-success">Initial loading</span>
    } @case (Status.Creating) {
    <span class="badge badge-success">Creating</span>
    } @case (Status.BackupStandBy) {
    <span class="badge badge-success">Backup standby</span>
    } @case (Status.Stopped) {
    <span class="badge badge-danger">Stopped</span>
    } @case (Status.Stopping) {
    <span class="badge badge-danger">Stopping</span>
    } @case (Status.Failed) {
    <span class="badge badge-danger">Failed</span>
    } @default {
    <span class="badge badge-dark">-</span>
    } } @if (params.data.hasIssues) {
    <a
      class="text-warning ml-2"
      href="configuration/{{ params.data.id }}/logs/history-logs?logType=3&logType=5"
      target="_blank"
      data-toggle="tooltip"
      data-placement="bottom"
      title="Replication has issues or is not working at all"
      aria-label="Open the issue list in another tab"
    >
      <span class="fa fa-exclamation-triangle" aria-hidden="true" title="Warning"></span>
    </a>
    }
  </div>
</ng-template>

<ng-template #deleteConfirmation>
  @if (selectedConfiguration.sscEnabled) {
  <div>
    <p>There is an active SharePoint Structure Creator at this configuration. We strongly recommend to deactivate it first before deleting configuration.</p>
    <p>
      In case you cannot deactivate SharePoint Structure Creator from our app and your Dynamics 365 instance is still accessible, make sure you have deleted `Connecting Software Structure Creator`
      managed solution from Dynamics 365.
    </p>
  </div>
  }
  <div>
    <p>
      <strong>Are you sure you want to delete configuration {{ selectedConfiguration.name }}?</strong>
    </p>
    @if (isSaaS) {
    <p>Kindly note that all your subscriptions will be lost."</p>
    }
  </div>
</ng-template>
